<template>
  <ButtonSnsSmall class="btn-sns--link" @click-sns-button="onClick" />
</template>

<script>
import ButtonSnsSmall from '../../../atoms/buttons/ButtonSnsSmall.vue'
export default {
  components: { ButtonSnsSmall },
  methods: {
    onClick() {
      this.$emit('click-link-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-sns--link {
  @include bg-settings(
    '../../../../../../images/buttons/link-with-background.svg',
    $gray-2,
    100%,
    100%
  );
}
</style>
